import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackAssetModalInfoPanelSectionToggled = {
  section: 'boards' | 'customFields' | 'customMetadata' | 'smartMetadata' | 'fileInfo' | 'advanced';
  isExpanded: boolean;
};

export const useTrackAssetModalInfoPanelSectionToggled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalInfoPanelSectionToggled = useCallback(
    ({ section, isExpanded }: TrackAssetModalInfoPanelSectionToggled) => {
      track(`Toggled asset modal info panel section`, { isExpanded, section });
    },
    [track],
  );

  return { trackAssetModalInfoPanelSectionToggled };
};
